



































import { Component, Prop, Vue } from 'vue-property-decorator'
import * as modules from '../../../store/decorator'
import vLeafletMaps from './VLeafletMaps.vue'
import { isOnline } from '../../../utils/services'
import axios from 'axios'

@Component({
    components: {
        vLeafletMaps
    }
})
export default class VAddress extends Vue {

    @Prop(String) label!: string
    @Prop(Object) menuProps!: object
    @Prop(Array) errorMessages!: Array < object >
    @Prop() value!: any

    items: Array <string> = []
    onlineStatus: boolean = false

    doNotTrack: boolean = false;

    assetSearch = '';
    assetQuery = '';
    showWW: boolean = true;
    showSW: boolean = false;
    showIF: boolean = true;
    activeTab = '';
    isInflow: boolean = false;

    latitude = 0;
    longitude = 0;
    assetNumber = '';

    addresstext = '';

    get isOnline() {
        return this.onlineStatus
    }

    async WWChanged(isActive: any) {
      this.showWW = isActive.target.checked;
      this.assetQuery = this.assetSearch = this.activeTab = '';
    }
    async SWChanged(isActive: any) {
      this.showSW = isActive.target.checked;
      this.assetQuery = this.assetSearch = this.activeTab = '';
    }
    async IFChanged(isActive: any) {
      this.showIF = isActive.target.checked;
      this.assetQuery = this.assetSearch = this.activeTab = '';
    }

    pointClicked(value: any) {
      this.latitude = value.latLng.lat;
      this.longitude = value.latLng.lng;
      this.assetNumber = value.data.asset_id;
      this.addressUpdated();
    }

    latlngUpated() {
      // Always store coordinates, whether creating or editing
      let uniqueId: any = document.querySelectorAll('#surveyUniqueId')[0].getAttribute('value');
      modules.survey.store({
        [uniqueId]: {
          ['details']: {
            ['attributes0']: {
              ['lat']: this.latitude,
              ['lng']: this.longitude,
            }
          }
        }
      })
    }

    addressUpdated() {
      let uniqueId: any = document.querySelectorAll('#surveyUniqueId')[0].getAttribute('value');
      let txt = this.addresstext;
      if(this.assetNumber === null) {
        modules.survey.store({
          [uniqueId]: {
            ['details']: {
              ['attributes0']: {
                ['assetNo']: null
              }
            }
          }
        })
      } else {
        txt = this.assetNumber + ' - ' + this.addresstext;
        modules.survey.store({
          [uniqueId]: {
            ['details']: {
              ['attributes0']: {
                ['assetNo']: this.assetNumber
              }
            }
          }
        })
      }
      if( txt.split(' - ')[1].length < 1 ) {
        txt = '';
      }
      if( txt.split(' - ')[0].length < 1 ) {
        txt = txt.replace(' - ', '');
      }
      this.latlngUpated();
      this.doNotTrack = true;
      this.$emit('change', txt);
    }

    geoUpdated(value: any) {
      this.items = [];
      this.addresstext = '';
      if(value.data && value.data.results && value.data.results.length > 0) {
        this.items.indexOf(value.data.results[0].formatted_address) === -1 ? this.items.push(value.data.results[0].formatted_address) : false
        if( this.items.length > 0 ) {
          this.addresstext = this.items[0];
          this.addressUpdated();
        }
      }
    }

    geoLoaded = false;
    geoInterval: any;
    async mounted() {
      if( this.$route.fullPath.indexOf('wastewater') > -1 && this.$route.fullPath.indexOf('inflow-inspection') > -1 ) this.isInflow = true;

      clearInterval(this.geoInterval);
      this.latitude = modules.user.customerDetail.latitude;
      this.longitude = modules.user.customerDetail.longtitude;
      
      // Check if we're in edit mode and load saved coordinates
      const edittarget = this.$route.query.uuid;
      if (edittarget) {
        const uuid = Array.isArray(edittarget) ? edittarget[0] : edittarget;
        await this.loadSavedCoordinates(uuid);
      } else {
        // Only get current location if not in edit mode
        if( navigator.geolocation ) {
          navigator.geolocation.getCurrentPosition(function () {}, function () {}, {});
          navigator.geolocation.getCurrentPosition(pos => {
            this.latitude = pos.coords.latitude;
            this.longitude = pos.coords.longitude;

            this.latlngUpated();

            this.geoLoaded = true;
            clearInterval(this.geoInterval);
          }, err => {

          }, {maximumAge:60000, timeout: 2000, enableHighAccuracy:true});

          navigator.geolocation.watchPosition(pos => {
            if( this.latitude == 0 ) {
              if( !this.doNotTrack ) {
                this.latitude = pos.coords.latitude;
                this.longitude = pos.coords.longitude;
              }
            }
          }, err => {
          }, {enableHighAccuracy:true});
        } else {
          // eslint-disable-next-line
          console.log('geolocation not supported');
        }
      }

      this.getAddress();
    }

    async loadSavedCoordinates(uuid: string) {
      try {
        const { localForage } = await import('../../../utils/services');
        const surveyData = await localForage.getSurveyItem(uuid);
        
        if (surveyData && surveyData.data && surveyData.data.details && surveyData.data.details.attributes0) {
          const attrs = surveyData.data.details.attributes0;
          
          // Try both possible field names
          if (attrs.lat && attrs.lng) {
            this.latitude = parseFloat(attrs.lat);
            this.longitude = parseFloat(attrs.lng);
          } else if (attrs.latitude && attrs.longitude) {
            this.latitude = parseFloat(attrs.latitude);
            this.longitude = parseFloat(attrs.longitude);
          }
          
          // Load asset number and address
          if (attrs.assetNo) {
            this.assetNumber = attrs.assetNo;
          }
          
          if (attrs.address) {
            // Extract address text from stored address (format: "ASSET123 - 123 Main St")
            const addressParts = attrs.address.split(' - ');
            if (addressParts.length > 1) {
              this.addresstext = addressParts.slice(1).join(' - '); // Everything after first " - "
            }
          }
          
          // Store the loaded coordinates back to the survey store
          this.latlngUpated();
          
          // Call addressUpdated to store asset number and emit change event
          if (this.assetNumber || this.addresstext) {
            this.addressUpdated();
          }
        }
      } catch (error) {
        // Silently handle errors during coordinate loading
      }
    }

    async getAddress() {
        // if (await isOnline()) this.onlineStatus = true
        this.onlineStatus = true

        const edittarget = this.$route.query.uuid;

        const instance = axios.create()
        instance.get('https://maps.googleapis.com/maps/api/geocode/json?', {
            params: {
                key: 'AIzaSyDOChq759QABLcNroIYv9jp6Ys3aMgwCig',
                latlng: `${ this.latitude },${ this.longitude }`,
                sensor: true,
                type: 'address'
            }
        }).then(response => {

            if (response.status !== 200) return

            // check if this call succeeded or not -  google call may fail and then there will be no address returned
            if(response.data && response.data.results && response.data.results.length > 0) {
                this.items.indexOf(response.data.results[0].formatted_address) === -1 ? this.items.push(response.data.results[0].formatted_address) : false
            }
            
            // Only update address text if not in edit mode to preserve saved data
            if (!edittarget && this.items.length > 0) {
              this.addresstext = this.items[0];
            }

            if (this.value) {
              const valueFragments = this.value.split(' - ');
              // Only update asset number from address value if not in edit mode
              // In edit mode, preserve the loaded asset number
              if (!edittarget) {
                this.assetNumber = valueFragments[0];
              }
              this.addresstext = valueFragments[1];
              // Only call addressUpdated if not in edit mode to avoid overriding saved coordinates
              if (!edittarget) {
                this.addressUpdated();
              }
            }
        })
    }

}
